(function() {
  var loading = false;
  var done = false;
  var nextUrl = null;
  var grid = null;
  var spinner = null;

  function init() {
    grid = document.getElementById('product-grid');
    var wrapper = document.querySelector('.pagination-wrapper');
    if (!grid || !wrapper) return;

    nextUrl = wrapper.getAttribute('data-next-url');
    if (!nextUrl) return;

    wrapper.style.display = 'none';

    spinner = document.createElement('div');
    spinner.style.cssText = 'text-align:center;padding:2rem;display:none;';
    spinner.innerHTML = "<p style=\"color:#480024;font-size:0.9rem;\">Loading more products...</p>";
    var collectionContainer = document.querySelector('#ProductGridContainer') || grid.parentNode.parentNode;
    collectionContainer.insertAdjacentElement('afterend', spinner);

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function onScroll() {
    if (loading || done) return;

    var gridBottom = grid.getBoundingClientRect().bottom;
    var windowHeight = window.innerHeight;

    if (gridBottom - windowHeight < 600) {
      loadMore();
    }
  }

  function loadMore() {
    if (!nextUrl || loading || done) return;
    loading = true;
    if (spinner) spinner.style.display = 'block';

    fetch(nextUrl)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newGrid = tmp.querySelector('#product-grid');
        if (newGrid) {
          var items = newGrid.querySelectorAll('.grid__item');
          items.forEach(function(item) {
            grid.appendChild(item.cloneNode(true));
          });
        }
        var newWrapper = tmp.querySelector('.pagination-wrapper');
        var newNext = newWrapper ? newWrapper.getAttribute('data-next-url') : null;
        if (newNext) {
          nextUrl = newNext;
        } else {
          done = true;
          window.removeEventListener('scroll', onScroll);
          if (spinner) spinner.innerHTML = "<p style=\"color:#888;font-size:1.85rem;\">That's All Divas !!</br> Explore our other collections.</p>";
          setTimeout(function() { if (spinner) spinner.style.display = 'none'; }, 20000);
        }
        loading = false;
        if (!done && spinner) spinner.style.display = 'none';
        onScroll();
      })
      .catch(function(e) {
        console.error('Infinite scroll error:', e);
        loading = false;
        done = true;
        window.removeEventListener('scroll', onScroll);
        if (spinner) spinner.style.display = 'none';
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();